import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevrons-down-right', 'ChevronsDownRight', [["path",{"d":"M13 5v8h-8"}],["path",{"d":"M17 9v8h-8"}]]);